import { render, staticRenderFns } from "./OutfitItem.vue?vue&type=template&id=6d2e4d4e&scoped=true&"
import script from "./OutfitItem.vue?vue&type=script&lang=js&"
export * from "./OutfitItem.vue?vue&type=script&lang=js&"
import style0 from "./OutfitItem.vue?vue&type=style&index=0&id=6d2e4d4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2e4d4e",
  null
  
)

export default component.exports